export const KEY_LAYER_CHAIN = Symbol("layerChain"),
    KEY_LAYER_SUB_CHAIN = Symbol("layerSubChain"),
    SYM_METHOD = Symbol('method'),
    SYM_ELEMENT_REF = Symbol('elementRef'),
    SYM_LAYER_CACHING = Symbol('layers'),
    SYM_LAYER_INDENTIFY = Symbol('layerIdentify'),
    SYM_LAYER_UID = Symbol('layerUID'),
    SYM_SANDBOX = Symbol("Sandbox"),
    SYM_CACHING = Symbol('caching'),
    SYM_ROOT_PROP = Symbol('rootProps'),
    SYM_IS_PROP_ROOT = Symbol('isRoot'),
    SYM_PROP_LINKING = Symbol('linking'),
    SYM_SPECIAL_DEPS = 'rcz_specialDeps'